<template>
  <div id="forget_password_form" class="form-bg">
    <div class="title font-semi-bold">{{lbl.forgetpassword.forgetpassword}}</div>
    <div class="form-width">
        <ContactNumber
            v-model="forgetpassword"
            inputId="forget-password"
            :inputLbl="lbl.forgetpassword.mobileNumber"
            :isFirstSave="isFirstSave"
            :isShowErrorLbl="true"
            :errorInfo="errorInfo[0]"
        ></ContactNumber>
    </div>
    <div class="pt-4 pb-2">
        <div class="wrapper-btn mx-auto text-center">
            <OutlineYellowButton @onClick="onClickBack()">
                <div class="font-main">{{ lbl.btn_back }}</div>
            </OutlineYellowButton>
            <OrangeButton @onClick="onClickSubmit()">
                <div class="font-main">{{ lbl.default.submit }}</div>
            </OrangeButton>
        </div>
    </div>
  </div>
</template>

<script>
import FormHelper from '@/helper/FormHelper';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
//component
import ContactNumber from '@/components/Input/ContactNumber.vue';
import OrangeButton from '@/components/Button/OrangeButton.vue';
import OutlineYellowButton from '@/components/Button/OutlineYellowButton.vue';

export default {
    components:{
        OrangeButton,
        OutlineYellowButton,
        ContactNumber
    },
    mixins: [LocaleMixin],
    data: function(){
        return {
            forgetpassword: '',
            isFirstSave: true,
            errorInfo: []
        }
    },
    created: function(){
        this.errorInfo = FormHelper.genErrorInfo(1);
    },
    methods:{
        onClickSubmit:function(){
            this.isFirstSave = false
            let isValid = FormHelper.validate(this.errorInfo);
            if(isValid){
                this.$emit('update', this.forgetpassword);
            }
        },
        onClickBack: function(){
            this.$router.back();
        }
    }

}
</script>
<style lang="scss">
 @import "@/style/base/base.scss";
#forget_password_form
{
    .wrap-input{
        .input-box {
            .input-field{
                color: $a-black-333333;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
.form-bg{
    max-width: 445px;
    flex-grow: 0;
    margin: auto;
    padding: 20px 30px 20px 30px;
    border-radius: 20px;
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.25);
    background-color: #fff;
}
.title{
    text-align: center;
    color: $a-black-333333;
    font-size: 16px;

    @include min-desktop {
        font-size: 18px;
    }
}
.form-width{
    width: 100%;
    max-width: 400px;
    display: flex;
    margin: auto;
}
.wrapper-btn{
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
}
</style>
